import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        user_id: String,
        seat_id: String,
    }

    connect() {

        this.tabElement = document.querySelector(`#user-view-${this.userIdValue}-tab button`)
        this.tab = bootstrap.Tab.getOrCreateInstance(this.tabElement)


        if (this.hasSeatIdValue && this.seatIdValue !== "") {
            const seatElement = document.querySelector(`.seat[data-id="${this.seatIdValue}"]`)
            
            this.tabElement.addEventListener('shown.bs.tab', event => {
                seatElement.classList.add('target');
            })

            this.tabElement.addEventListener('hidden.bs.tab', event => {
                seatElement.classList.remove('target');
            })
        }

        this.tab.show()
    }

    close({ detail: { content } }) {
        if (content === this.userIdValue) {

            bootstrap.Tab.getOrCreateInstance(this.tabElement).dispose()
            document.querySelector(`#user-view-${this.userIdValue}-tab`).remove()
            bootstrap.Tab.getOrCreateInstance('#users-tab').show()


        }
    }
}
